import { topicsData } from '@/mocks/comics';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500">
            漫画爱好者正在热议的话题标签
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#topics"
              className="group flex items-center gap-3 px-5 py-3 bg-background-50 border border-background-200 rounded-full hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                #{topic.name}
              </span>
              <span className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                {topic.count}{topic.unit}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}